import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../common/axios';
import Swal from 'sweetalert2';
import dayjs from "dayjs";

const AgreementPage = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/getagreement'); 
        if(res.data.success){
          setData(res.data.data);
        }
      } catch (error) {
        console.error(t('agreementLog.fetchError'), error);
      }
    };
    fetchData();
  }, []);
  
  const handleButtonAPIClick = (v) => {
    Swal.fire({
      title: t('agreementLog.modifyRequestTitle'),
      text: t('agreementLog.modifyRequestText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('agreementLog.confirm'),
      cancelButtonText: t('agreementLog.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/udpatecontract3?record=${v.record}&project=${v.projectCode}`)
        .then(response => {
          if(response.data.success){
            Swal.fire({
              title: t('agreementLog.successTitle'),
              text: t('agreementLog.successText'),
              icon: 'success',
              confirmButtonText: t('agreementLog.confirm')
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/log-agreement";
              }
            });
          } else {
            Swal.fire({
              title: t('agreementLog.errorTitle'),
              text: t('agreementLog.errorText'),
              icon: 'error',
              confirmButtonText: t('agreementLog.confirm')
            });
          }
        })
        .catch(error => {
          Swal.fire({
            title: t('agreementLog.errorTitle'),
            text: t('agreementLog.errorText'),
            icon: 'error',
            confirmButtonText: t('agreementLog.confirm')
          });
        });
      }
    });
  };
  
  const handleButtonAPIClick2 = (v) => {
    Swal.fire({
      title: t('agreementLog.proceedRequestTitle'),
      text: t('agreementLog.proceedRequestText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('agreementLog.confirm'),
      cancelButtonText: t('agreementLog.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/udpatecontract4?record=${v.record}&project=${v.projectCode}`)
        .then(response => {
          if(response.data.success){
            Swal.fire({
              title: t('agreementLog.successTitle'),
              text: t('agreementLog.proceedSuccessText'),
              icon: 'success',
              confirmButtonText: t('agreementLog.confirm')
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/log-agreement";
              }
            });
          } else {
            Swal.fire({
              title: t('agreementLog.errorTitle'),
              text: t('agreementLog.errorText'),
              icon: 'error',
              confirmButtonText: t('agreementLog.confirm')
            });
          }
        })
        .catch(error => {
          Swal.fire({
            title: t('agreementLog.errorTitle'),
            text: t('agreementLog.errorText'),
            icon: 'error',
            confirmButtonText: t('agreementLog.confirm')
          });
        });
      }
    });
  };

  return (
    <div className='app-content flex-column-fluid'>
      <div className='app-container container-xxl'>
        <div className="card mb-5 mb-xl-8">
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label fw-bold fs-3 mb-1">{t('agreementLog.title')}</span>
              <span className="text-muted mt-1 fw-semibold fs-7">{data && data.filter(v => v.status === "Agreement_Transfer").length}{t('agreementLog.pendingAgreements')}</span>
            </h3>
            <div className="card-toolbar"></div>
          </div>
          <div className="card-body py-3">
            <div className="table-responsive">
              <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                <thead>
                  <tr className="fw-bold text-muted">
                    <th className="min-w-100px">{t('agreementLog.projectName')}</th>
                    <th className="min-w-150px">{t('agreementLog.contractName')}</th>
                    <th className="min-w-80px">{t('agreementLog.status')}</th>
                    <th className="min-w-100px"></th>
                    <th className="min-w-140px">{t('agreementLog.expectedAmount')}</th>
                    <th className="min-w-120px">{t('agreementLog.workName')}</th>
                    <th className="min-w-140px">{t('agreementLog.preWorkReason')}</th>
                    <th className="min-w-100px">{t('agreementLog.workStartDate')}</th>
                    <th className="min-w-100px">{t('agreementLog.estimateDeadline')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 && data.map((v, index) => (
                    <tr key={index}>
                      <td className="text-dark fw-bold text-hover-primary fs-7">{v.projectName}</td>
                      <td className="text-dark fw-bold text-hover-primary fs-7">{v.계약명}</td>
                      <td>
                        <span className={v.status === "Agreement_Transfer" ? "badge badge-light-danger" : "badge badge-light-success"}>
                          {v.status === "Agreement_Transfer" ? t('agreementLog.responseNeeded') : t('agreementLog.responseNotNeeded')}
                        </span>
                      </td>
                      <td>
                        {v.status === "Agreement_Transfer" && (
                          <>
                            <button className="btn btn-sm btn-light" style={{ padding: 5 }} onClick={() => handleButtonAPIClick(v)}>{t('agreementLog.modifyRequest')}</button><br />
                            <button className="btn btn-sm btn-light" style={{ padding: 5 }} onClick={() => handleButtonAPIClick2(v)}>{t('agreementLog.proceedToSign')}</button>
                          </>
                        )}
                      </td>
                      <td className="text-dark fw-bold text-hover-primary fs-7">{v["하수급금액(예상, VAT 제외)"] && v["하수급금액(예상, VAT 제외)"].toLocaleString()}원</td>
                      <td className="text-dark fw-bold text-hover-primary fs-7">{v["작업명"]}</td>
                      <td className="text-dark fw-bold text-hover-primary fs-7">{v["선작업 사유"]}</td>
                      <td className="text-dark fw-bold text-hover-primary fs-8">{dayjs(v["작업시작일"]).format("YY-MM-DD")}</td>
                      <td className="text-dark fw-bold text-hover-primary fs-8">{dayjs(v["견적제출 마감일"]).format("YY-MM-DD")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgreementPage;
